"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabModern = exports.StyledTabModernIcon = exports.StyledTabModernText = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const buttonReset_styles_1 = require("../../../../DesignSystem/styles/buttonReset.styles");
const typography_styles_1 = require("../../../../DesignSystem/styles/typography.styles");
const Tab_1 = require("../../../designTokens/Tab");
const TabList_1 = require("../../../designTokens/TabList");
const Text_1 = require("../../../../Text");
exports.StyledTabModernText = (0, styled_components_1.default)(Text_1.Text) `
    ${typography_styles_1.fontM};
`;
exports.StyledTabModernIcon = styled_components_1.default.svg `
    flex-shrink: 0;
`;
exports.StyledTabModern = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    display: flex;
    align-items: flex-start;
    padding-top: ${Tab_1.tabTokens.tabPaddingTop.getVar()};
    padding-right: ${Tab_1.tabTokens.tabPaddingRight.getVar()};
    padding-bottom: ${Tab_1.tabTokens.tabPaddingBottom.getVar()};
    padding-left: ${Tab_1.tabTokens.tabPaddingLeft.getVar()};
    gap: ${Tab_1.tabTokens.tabIconGap.getVar()};
    border-right: ${TabList_1.tabListTokens.tabListBorderWidth.getVar()} solid
        ${TabList_1.tabListTokens.tabListBorderColor.getVar()};

    ${({ isDisabled }) => isDisabled
    ? (0, styled_components_1.css) `
                  cursor: default;

                  &,
                  ${exports.StyledTabModernText} {
                      color: ${Tab_1.tabTokens.tabDisabledColor.getVar()};
                  }
              `
    : (0, styled_components_1.css) `
                  cursor: pointer;
                  background-color: ${Tab_1.tabTokens.tabBackgroundColor.getVar()};

                  &,
                  ${exports.StyledTabModernText} {
                      color: ${Tab_1.tabTokens.tabColor.getVar()};
                  }

                  &:hover {
                      &,
                      ${exports.StyledTabModernText} {
                          color: ${Tab_1.tabTokens.tabHoverColor.getVar()};
                      }
                  }
              `}
`;
//# sourceMappingURL=TabModern.styles.js.map